<template>
    <rkm-layout-body title="Lista de papéis">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'administracao-papel-create' })"
                color="primary"
                authorize="store-administracao-papel"
            >
                Cadastrar papel
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/administracao/papel/List'

export default {
    components: { List }
}
</script>